import { Avatar } from '@mui/material';
import { ReactNode } from 'react';
import { AccessoryDrawer, AccessoryDrawerButton } from '../AccessoryDrawer/AccessoryDrawer';

export function AccountMenuDrawerButton({ userInitials }: { userInitials?: string | undefined }) {
  return (
    <AccessoryDrawerButton
      drawerKey="accountMenu"
      // Caution - ARIA labels can be used by consumers in E2E tests
      label="Open account menu"
      icon={<Avatar sx={{ width: 32, height: 32 }}>{userInitials}</Avatar>}
      sx={{ p: 0.5 }}
    />
  );
}

export function AccountMenuDrawer({ children }: { children?: ReactNode }) {
  return (
    <AccessoryDrawer
      drawerKey="accountMenu"
      slotProps={{
        content: { sx: { minHeight: '100%', display: 'flex', flexDirection: 'column', pt: 1, gap: 1, pb: 2 } },
      }}
    >
      {children}
    </AccessoryDrawer>
  );
}
